import { isAppUsing } from '@@/bits/flip'

export const isPartOfUnlimitedSandboxesEvent = (): boolean => {
  return isAppUsing('unlimitedSandboxes') && new Date() < new Date(Date.UTC(2024, 9, 1, 0, 0, 0))
}
